import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Components
import BodyWrap from "../utils/BodyWrap";

// State
import { userLogout } from "../../store/actions/user";

class ReviewerLogout extends Component {
	componentWillMount() {
		this.props.userLogout("reviewer");
	}

	render() {
		return (
			<main className="body_container padded_top padded_bottom">
				<BodyWrap>
					<h1>Logout</h1>

					<div className="product_section">
						<div>You are now logged out.</div>
						<Link to={"/reviewer/login"}>
							If you would like to login again please click here.
						</Link>
					</div>
				</BodyWrap>
			</main>
		);
	}
}

export default connect(
	null,
	{ userLogout }
)(ReviewerLogout);



// WEBPACK FOOTER //
// ./src/components/reviewer/ReviewerLogout.js